// packages/shared-hooks/src/api/context.tsx
// Spec §18: React-context-based ApiClient injection. Every hook calls
// `useApiClient()`. Missing provider throws — there's no implicit default.
import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from './types.js';

const ApiClientContext = createContext<ApiClient | null>(null);

export function ApiClientProvider({
  client,
  children,
}: {
  client: ApiClient;
  children: ReactNode;
}) {
  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>;
}

export function useApiClient(): ApiClient {
  const c = useContext(ApiClientContext);
  if (!c) throw new Error('useApiClient: missing ApiClientProvider');
  return c;
}
